"use client";

import { X, Check } from "lucide-react";
import { useTranslations } from "next-intl";

import { BrandLogo } from "~/components/ui/brand-logo";

export function PainVsGain() {
  const t = useTranslations("landing.painVsGain");

  const beforeItems = [0, 1, 2, 3, 4].map((i) => t(`before.items.${i}`));
  const afterItems = [0, 1, 2, 3, 4].map((i) => t(`after.items.${i}`));

  return (
    <section className="overflow-hidden bg-white py-24 dark:bg-gray-950">
      <div className="container mx-auto px-4">
        <div className="mx-auto mb-16 max-w-3xl text-center">
          <h2 className="mb-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl dark:text-white">
            {t("title")}
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300">
            {t("description")}
          </p>
        </div>

        <div className="relative mx-auto grid max-w-5xl gap-12 md:grid-cols-2">
          {/* VS Badge */}
          <div className="absolute top-1/2 left-1/2 z-10 hidden h-12 w-12 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-4 border-gray-50 bg-white text-sm font-bold text-gray-400 shadow-lg md:flex dark:border-gray-900 dark:bg-gray-800">
            VS
          </div>
          {/* The Old Way */}
          <div className="group relative">
            <div className="absolute inset-0 rotate-1 transform rounded-3xl bg-red-50/50 transition-transform group-hover:rotate-2 dark:bg-red-950/10" />
            <div className="relative h-full rounded-3xl border border-red-100 bg-white p-8 dark:border-red-900/30 dark:bg-gray-900">
              <div className="mb-6 flex items-center gap-3">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-red-100 text-red-600 dark:bg-red-900/50 dark:text-red-400">
                  <X className="h-6 w-6" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 dark:text-white">
                  {t("before.title")}
                </h3>
              </div>
              <ul className="space-y-4">
                {beforeItems.map((item, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-3 text-gray-600 dark:text-gray-400"
                  >
                    <X className="mt-0.5 h-5 w-5 shrink-0 text-red-400" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* The NotreImmeuble Way */}
          <div className="group relative">
            <div className="absolute inset-0 -rotate-1 transform rounded-3xl bg-teal-50/50 transition-transform group-hover:-rotate-2 dark:bg-teal-950/10" />
            <div className="relative h-full rounded-3xl border border-teal-100 bg-white p-8 shadow-xl shadow-teal-900/5 dark:border-teal-900/30 dark:bg-gray-900">
              <div className="mb-6 flex items-center gap-3">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-teal-100 text-teal-600 dark:bg-teal-900/50 dark:text-teal-400">
                  <Check className="h-6 w-6" />
                </div>
                <h3 className="flex items-center gap-2 text-xl font-bold text-gray-900 dark:text-white">
                  <span>
                    {t("after.title").replace("NotreImmeuble", "").trim()}
                  </span>
                  <BrandLogo />
                </h3>
              </div>
              <ul className="space-y-4">
                {afterItems.map((item, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-3 font-medium text-gray-900 dark:text-gray-200"
                  >
                    <Check className="mt-0.5 h-5 w-5 shrink-0 text-teal-500" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
